import {Component, OnDestroy, OnInit} from '@angular/core';
import {BreadcrumbModel} from '@shared/models/breadcrumb.model';
import {Router, ActivatedRoute} from '@angular/router';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {select, Store} from '@ngrx/store';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {QueryProvider} from '@shared/queries/query-provider';
import {Configuration} from '@shared/models/configuration';
import {QueryModel} from '@shared/models/query-model';
import {DeleteQueryAction} from '@shared/store/actions/query.actions';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {
  AcceptResponseCommand,
  DataSurveyResponseExportCommand,
  RejectResponseCommand
} from '../../commands/survey.commands';
import {DialogService} from '@shared/services/dialog-service';
import {CommandService} from '@core/services/command.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {Observable} from 'rxjs';
import { DialogModel } from '@shared/models/dialog.model';
import { FileManagementService } from '@core/services/file-management.service';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import {InvalidateSubject} from "@shared/helpers/invalidate.subject";


@Component({
    standalone: false,
    selector: 'particle-data-survey-execution-details',
  templateUrl: './data-survey-execution-details.component.html',
  styleUrls: ['./data-survey-execution-details.component.scss']
})
export class DataSurveyExecutionDetailsComponent implements OnInit, OnDestroy {
  surveyId: string;
  executionId: string;
  breadcrumbs: BreadcrumbModel[];
  breadcrumbs$: any;
  breadcrumbKey: string;
  sourceKey: string;
  breadcrumbQueryModel: QueryModel;
  ngUnsubscribe: Subject<void> = new Subject<void>();
  invalidateSubject = new InvalidateSubject();

  constructor(protected store: Store<IQueryState>,
              private router: Router,
              private dialogService: DialogService,
              private commandService: CommandService,
              public snackBarService: SnackBarService,
              protected activatedRoute: ActivatedRoute,
              private fileManagementService: FileManagementService,
              private fuseSplashScreenService: FuseSplashScreenService
              ) {
    this.breadcrumbs = [
      <BreadcrumbModel>{
        id: 'DataSurvey',
        title: 'Data Survey',
        type: 'DataSurvey',
        relativeUrl: 'data-survey'
      }
    ];
    this.breadcrumbKey = 'BreadcrumbByExecutionId';
    this.sourceKey = 'DataSurveyResponse';
  }

  ngOnInit() {
    this.activatedRoute.params.subscribe((params: any) => {
      this.surveyId = params.surveyId;
      this.executionId = params.executionId;

      const config = Configuration.getSmartGridConfig(this.sourceKey);
      config.Parameters['ExecutionId'] = this.executionId;

      this.breadcrumbQueryModel = QueryProvider.getQuery(this.breadcrumbKey);
      this.breadcrumbs$ = this.store.pipe(select(getQueryResponse, this.breadcrumbKey));
      this.breadcrumbs$.subscribe(state => {
        if (state) {
          this.breadcrumbs = state.breadcrumb;
        }
      });
      QueryProvider.invokeQuery(this.store, this.breadcrumbKey, {'[ID]': this.executionId});
    });

  }

  onGridCellValueChange($event) {
    console.log('Clicked', $event);
    if ($event.fieldDefinition.key === 'code' && $event.item.cells['ViewType'] && $event.item.cells['ViewType'].value) {
      switch ($event.item.cells['ViewType'].value) {
        case 'Grid':
          this.router.navigateByUrl(`data-survey/response/${$event.item.id}/review`);
          break;
        case 'Form':
          this.router.navigateByUrl(`data-survey/form/${$event.item.id}/review`);
          break;
      }
    } else if ($event.action && $event.action.id === 'Accept') {
      this.acceptResponse($event.item);
    } else if ($event.action && $event.action.id === 'Reject') {
      this.rejectResponse($event.item);
    }
  }

  export() {
    const dialogModel = DialogModel.create('Export', 'ExportSurveyResponseDialogComponent', {
      surveyId: this.surveyId,
      executionId: this.executionId
    });
    dialogModel.minWidth = '800px';
    dialogModel.maxWidth = '800px';
    this.dialogService.showOkCancelDialog(dialogModel)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(actionState => {
        if (actionState && actionState.action === 'OK') {
          const command = new DataSurveyResponseExportCommand(actionState.data.input.executionSourceType,this.executionId,this.surveyId);
          this.fuseSplashScreenService.show();
          this.commandService.executeCommand(command)
            .pipe().subscribe(state => {
            this.fileManagementService.downloadClientFileWithId(state.Payload.FileId).pipe().subscribe((payload: any) => {
              this.fuseSplashScreenService.hide();
              this.fileManagementService.openSaveFileWindow(payload, state.Payload.FileName);
            }, (error) => this.fuseSplashScreenService.hide());
          }, (error) => this.fuseSplashScreenService.hide());
        }
      });
  }

  acceptResponse(response: any) {
    this.dialogService.showTextAreaInputDialog('Approve Changes', '', 'Comment').pipe(takeUntil(this.ngUnsubscribe)).subscribe(state => {
        if (state.action === 'OK') {
          console.log('Accept comment', state);
          const command = new AcceptResponseCommand(response.id, state.data.input.text);
          this.commandService.executeCommand(command).pipe(takeUntil(this.ngUnsubscribe)).subscribe(commandStae => {
              this.snackBarService.showInformation(`You have accepted the response successfully`);
              this.invalidateSubject.invalidate();
            });
        }
      });
  }

  rejectResponse(response: any) {
    this.dialogService.showTextAreaInputDialog('Reject Response', '', 'Comment').pipe(takeUntil(this.ngUnsubscribe)).subscribe(state => {
      if (state.action === 'OK') {
        const command = new RejectResponseCommand(response.id, state.data.input.text);
        this.commandService.executeCommand(command).pipe(takeUntil(this.ngUnsubscribe)).subscribe(commandStae => {
          this.snackBarService.showInformation(`You have rejected the response successfully`);
          this.invalidateSubject.invalidate();
        });
      }
    });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.store.dispatch(new DeleteQueryAction(this.breadcrumbQueryModel, null, null));
  }
}
